export default {
  vehicleMake: "VehicleMake",
  AddVehicleMake: "AddVehicleMake",
  editVehicleMake: "EditVehicleMake",
};
